import {
  LuLayoutGrid,
  AccountCircle,
    LuSend,
    BsBoxSeam,
    FiRepeat,
    LuLogIn,
    LuLogOut,
    FiFileText,
    LuUser,
    LuItalic,
    LuGlobe,
    FiTool,
    LuUserCheck
  } from "@/Components/Icons/Icons";
  
  export const sidebarMenu = [
    {
      label: "Organization",
      icon: LuLayoutGrid,
      selected: true 
      
    },
    {
      label: "Airline",
      icon: LuSend,
    },
    {
      label: "Shipping Line",
      icon: BsBoxSeam,
    },
    {
      label: "Transactions",
      icon: FiRepeat,
  
    },
    {
      label: "Custom Imports",
      icon: LuLogIn,
      children: [
        { label: "Import Job", selected: true },
        { label: "Tracking" },
        
      ],   
     },
    { 
      label: "Custom Exports",
      icon: LuLogOut,
      children: [
        { label: "Export Job", selected: true },
        { label: "Tracking" },
        { label: "Container VGM" },
      ],
    },
    {
      label: "Reports",
      icon: FiFileText,
    },
    {
      label: "My Tripath",
      icon: LuUser,  
    },
    {
      label: "ICE GATE",
      icon: LuItalic,
    },
    {
      label: "Tripath Integrations",
      icon: LuGlobe,
    },
    {
      label: "Tools",
      icon: FiTool,
    },
    {
      label: "Administration",
      icon: LuUserCheck,
    }
  ];
  